import { ExclamationTriangleIcon } from "@heroicons/react/24/solid";
import { Badge, Text } from "@components/theming";

export default function EventSubDescription({
  subdescription,
}: {
  subdescription: string;
}) {
  return (
    <Badge
      size="3"
      color="yellow"
      whitelabelClasses="mt-4 !whitespace-normal !items-start"
      shopsiteClasses="flex gap-1 !items-start px-[0.625rem] pt-[0.625rem] mt-4 lg:mt-6 lg:-mb-4 rounded-lg !bg-yellow-100 !text-yellow-700 ring-2 ring-yellow-600"
    >
      <ExclamationTriangleIcon className="h-7 w-7 p-1 shrink-0" />
      <Text
        as="div"
        color="yellow"
        shopsiteClasses="prose max-w-full text-yellow-700 prose-strong:text-yellow-700"
        dangerouslySetInnerHTML={{
          __html: subdescription,
        }}
      />
    </Badge>
  );
}
